<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Airline Entry",
      items: [
        {
          text: "Airline",
          href: "/",
        },
        {
          text: "Entry",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
      form: {
        airline_name: "",
        airline_short_name:"",
        airline_code: "",
      },
      submitform: false,
      submitted: false,
        message:"",
        visible:false,
    };
  },
  validations: {
    form: {
      airline_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      airline_short_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(10),
      },
      airline_code: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/airline/create", {
          name: this.form.airline_name,
          shortName:this.form.airline_short_name,
          code: this.form.airline_code,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.airlineEntryForm.reset();
            this.$swal("Good job!", "Airline Created", "success");
            this.$router.push({ name: "all_airlines" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else if(obj.message ==  "Forbidden request") {
          this.visible=true;
          this.message="role already assigned";
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="airlineEntryForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="airline_name">Airline Name</label>
                    <input
                      id="airline_name"
                      v-model="form.airline_name"
                      name="airline_name"
                      type="text"
                      class="form-control"
                      placeholder="Type airline name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.airline_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.airline_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="airline_code">Airline Code</label>
                    <input
                      id="airline_code"
                      v-model="form.airline_code"
                      name="airline_code"
                      type="text"
                      class="form-control"
                      placeholder="Type code"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.airline_code.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.airline_code.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_code.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="airline_short_name">Airline Short Name</label>
                    <input
                      id="airline_short_name"
                      v-model="form.airline_short_name"
                      name="airline_short_name"
                      type="text"
                      class="form-control"
                      placeholder="Type airline short name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.airline_short_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.airline_short_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_short_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>

              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
